import { FieldValue, Timestamp } from "firebase/firestore";

/**
 * Access level configuration for a pass-to-event mapping.
 * Determines whether this is primary (full) or secondary (discovery) access.
 */
export interface PassAccessLevel {
  /** If true, this pass has PRIMARY access to the mapped events */
  primary: boolean;
  /** Specific event IDs to exclude even if they match the vertical */
  excludedEventIds?: string[];
}

/**
 * Pass-to-Event mapping document.
 * Defines which events a pass grants access to and at what level.
 */
export interface PassEvent {
  id: string;
  /** Reference to passes/{id} or ticketTypes/{slug} */
  passId: string;
  /** Array of event IDs this pass grants access to */
  eventIds: string[];

  /** Access level configuration (primary vs secondary) */
  accessLevel?: PassAccessLevel;

  /**
   * Verticals to auto-map when new events are created.
   * E.g., ["tech"] means all new tech events are automatically added.
   */
  autoMapVerticals?: string[];

  /**
   * If true, this mapping is managed by auto-sync rules.
   * Manual changes may be overwritten when events are created/updated.
   */
  isAutoManaged?: boolean;

  /** Timestamp of last update */
  timestamp?: FieldValue | Timestamp;
}

/**
 * All C-Tribe verticals
 */
export const ALL_VERTICALS = [
  "tech",
  "fashion",
  "music",
  "gaming",
  "culture",
  "film",
  "health",
] as const;

export type PassVertical = (typeof ALL_VERTICALS)[number];
